const createFilterBar = ({ el, store }, Vue) => new Vue({
    el,
    data: store
});

export default createFilterBar;
